import React from "react";
import {
  makeStyles,
  Container,
  Typography,
  Divider,
  useMediaQuery,
} from "@material-ui/core";
import Form from "./Form";
import ContactButtons from "./ContactButtons";
import logo from "../../logo.svg";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    background: "linear-gradient(-90deg, #868f96,#596164)",
    minWidth: "103vw",
  },
  heading: {
    marginTop: "2vh",
    letterSpacing: "1px",
    color: "white",
  },
  divider: {
    height: "6px",
    width: "20%",
    margin: "1vh auto 3em auto",
    background: "linear-gradient(to right, #ffff00 0%, #33cc33 100%)",
  },
  formContainer: {
    background: "rgb(128,128,128, 0.7)",
    margin: "1em auto 2em auto",
    boxShadow: "0 10px 20px #000",
    transition: "transform .6s",
    "&:hover": {
      boxShadow: "0 10px 20px #000",
      transform: "scale(1.1)",
      [theme.breakpoints.down("md")]: {
        transform: "scale(1)",
      },
    },
  },
  contactInfo: {
    color: "white",
    letterSpacing: "3px",
  },
  poweredByContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "1.4em",
  },
  poweredByText: {
    padding: "2px",
  },
}));

function Contact(props) {
  const classes = useStyles();
  const matches = useMediaQuery("(max-width: 700px)");
  return (
    <div className={classes.mainContainer} id="contact">
      <Typography className={classes.heading} variant="h3" align="center">
        CONTACT
      </Typography>
      <Divider className={classes.divider} variant="fullWidth" />
      <Typography
        variant="h6"
        gutterBottom
        align="center"
        style={{ color: "white" }}
      >
        HAVE A QUESTION OR WANT TO WORK TOGETHER?
      </Typography>
      <Container maxWidth="sm" className={classes.formContainer}>
        <Form />
      </Container>
      <Typography
        className={`${classes.heading} ${classes.contactInfo}`}
        variant="h3"
        align="center"
      >
        | | @
      </Typography>
      <Typography
        className={`${classes.heading} ${classes.contactInfo}`}
        variant="h5"
        align="center"
      >
        {props.email}
      </Typography>
      <ContactButtons {...props} />
      <br></br>
      <br></br>
      <div className={classes.poweredByContainer}>
        <Typography
          variant="subtitle1"
          align="center"
          className={classes.poweredByText}
        >
          POWERED BY{" "}
        </Typography>
        <img
          src={logo}
          className="App-logo"
          alt="React-logo"
          style={{ width: matches ? "6%" : "4%" }}
        />
      </div>
    </div>
  );
}

export default Contact;
